/* eslint-disable array-callback-return */
import _ from "underscore";
import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../storeUtils";
import { StorageHelper } from "../../../utils/storageHelper";
import * as UtilsHelper from "../../../utils/utilsHelper";

const initialState = {
  zoneItems: [],
  artifactItems: [],
  selection: [],
  countrySiteList: {
    country: [],
    site: [],
  },
  selectedSiteID: "ALL",
  selectedCountryID: "ALL",
  selectedMilestoneID: "ALL",
  documentDataList: [],
  docLoading: false,
  roleList: [],
  studyUserInfo: {},
  userList: [],
  orgGuid: "",
  artifactPaginationInfo: [],
  metricsData: {},
  searchResult: {
    documentdetails: [],
  },
  searchView: false,
  searchLoader: false,
  viewPerPageCount: 20000,
  searchPageInfo: {
    activePage: 1,
    artifactid: "search",
    from: 0,
  },
  isReadOnlyAdmin: false,
  isReadOnlyUser: false,
  loadingArtifact: [],
  apiInitConfigObj: {},
  tmfList: [],
  auditList: [],
  listAudit: [],
  isRoleListLoaded: false,
  isEditLoading: false,
  aggridresultcount: 0,
  isAggridIconEnabled: false,
  sectionLoading: false,
  isOverViewLoading: false,
  artifactLoading: false,
  isZoneLoading: false,
  relocatedDoc: {},
  sharingDetails: [],
  isDocShareViedocUser: false,
  isDocShareViedocMeUser: false,
  isReadOnlySharingPanel: false,
  initialOverviewPageLoad: true,
  fileDetails: {},
  uploadProgress: { progress: 0 },
  updatedArtifactId: "",
  cancelDocId: [],
  recordState: "",
  docNewVersionXFDFString: "",
  isManageDropZoneAvailable : false,
  isUploadedNewVersionFile : false,
};

export const zoneReducer = (state = initialState, action = { type: "" }) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL_CLIENT_APIS:
      return updateObject(state, {
        selectedSiteID: "ALL",
        selectedCountryID: "ALL",
        selectedMilestoneID: "ALL",
        isEditLoading: true,
      });

    case actionTypes.SELECTED_FILTER_ID:
      const { id, name } = action;
      const filterData = StorageHelper.getFilterInfo();
      const latestSiteFilter =
        !_.isEmpty(filterData) &&
        filterData.selectedSiteID !== undefined &&
        filterData.selectedSiteID;
      const latestCountryFilter =
        !_.isEmpty(filterData) &&
        filterData.selectedCountryID !== undefined &&
        filterData.selectedCountryID;
      const latestMileFilter =
        !_.isEmpty(filterData) &&
        filterData.selectedMilestoneID !== undefined &&
        filterData.selectedMilestoneID;
      let newSiteID = latestSiteFilter
        ? latestSiteFilter
        : state.selectedSiteID;
      let newCountryID = latestCountryFilter
        ? latestCountryFilter
        : state.selectedCountryID;
      let newMilestoneID = latestMileFilter
        ? latestMileFilter
        : state.selectedMilestoneID;

      if (name === "site") {
        if (id !== "ALL") {
          const siteList = state.countrySiteList.site;
          const findObj = _.find(siteList, { id: id });
          newSiteID = id;
          newCountryID = findObj ? findObj.countryCode : "ALL";
        } else newSiteID = "ALL";
      }
      if (name === "country") {
        newCountryID = id;
        newSiteID = "ALL";
      }
      if (name === "countryOnly") {
        newCountryID = id;
      }
      if (name === "milestone") {
        newMilestoneID = id;
      }

      StorageHelper.setFilterInfo({
        selectedSiteID: newSiteID,
        selectedCountryID: newCountryID,
        selectedMilestoneID: newMilestoneID,
      });
      return updateObject(state, {
        selectedSiteID: newSiteID,
        selectedCountryID: newCountryID,
        selectedMilestoneID: newMilestoneID,
      });

    case actionTypes.ARTIFACT_REMOVED:
      const selectedListValue = state.documentDataList[
        action.payload.payload.origiartifactid
      ].findIndex((item) => item.documentid === action.payload.payload.id);
      state.documentDataList[action.payload.payload.origiartifactid][
        selectedListValue
      ].loader = true;
      return updateObject(state, {
        documentDataList: state.documentDataList,
      });

    case actionTypes.ARTIFACT_ITEM_REMOVED:
      const selectedIndexValue = state.documentDataList[
        action.payload.payload.origiartifactid
      ].findIndex((item) => item.documentid === action.payload.payload.id);
      state.documentDataList[action.payload.payload.origiartifactid].splice(
        selectedIndexValue,
        1
      );
      return updateObject(state, {
        documentDataList: state.documentDataList,
      });

    case `${actionTypes.GET_DOCUMENT_BY_SECTION}`:
      const payloadFrom = action.from;
      return updateObject(state, {
        docLoading: !_.isEmpty(payloadFrom),
        artifactPaginationInfo: [],
        sectionLoading: true,
      });
    case `${actionTypes.GET_DOCUMENT_BY_SECTION}_FAILED`:
      let newList2 = [...state.loadingArtifact];
      const resultFrom1 = action.from;
      if (!_.isEmpty(resultFrom1)) {
        newList2 = newList2.filter((list) => list !== resultFrom1);
      }
      return updateObject(state, {
        docLoading: false,
        loadingArtifact: [...newList2],
        sectionLoading: false,
        artifactLoading: false
      });

    case `${actionTypes.GET_DOCUMENT_BY_SECTION}_SUCCESS`:
      const { documentDetails, adminartifactsharingsettings } = action.payload;
      let newList1 = [...state.loadingArtifact];
      const resultFrom = action.from;


      let updatedData = documentDetails.map((gDoc) => {
        let displayDateTime = gDoc.lastmodifiedon
          ? UtilsHelper.momentLocalConversion(gDoc.lastmodifiedon, true)
          : UtilsHelper.momentLocalConversion(gDoc.createdon, true);
        displayDateTime =
          displayDateTime ||
          UtilsHelper.momentLocalConversion(new Date(), true);
        const displayOrder = UtilsHelper.constructDisplayOrder(gDoc.status);
        return { ...gDoc, displayDateTime, displayOrder };
      });
      updatedData = updatedData?.sort((a, b) =>
        b.displayDateTime.localeCompare(a.displayDateTime)
      );

      const groupByDisplayOrder = _.groupBy(updatedData, "displayOrder");

      let sortedRoleState = [];
      Object.keys(groupByDisplayOrder).map((key) => {
        sortedRoleState = [...sortedRoleState, ...groupByDisplayOrder[key]];
      });

      sortedRoleState = { [resultFrom]: sortedRoleState };
      if (!_.isEmpty(resultFrom)) {
        newList1 = newList1.filter((list) => list !== resultFrom);
      }
      sortedRoleState = !_.isEmpty(documentDetails)
        ? sortedRoleState
        : { [resultFrom]: [] };

      let sectionSortedRoleState = {};
      const artifactDocData = _.groupBy(updatedData, "origiartifactid");

      Object.keys(artifactDocData).map((artifactOrgId) => {
        let sortedArtifactData = []

        const groupByDisplayOrder = _.groupBy(artifactDocData[artifactOrgId], "displayOrder");

        Object.keys(groupByDisplayOrder).map((key) => {
          sortedArtifactData = [...sortedArtifactData, ...groupByDisplayOrder[key]];
        });

        sectionSortedRoleState = { ...sectionSortedRoleState, [artifactOrgId]: sortedArtifactData }
      });

      const adminSharing = !_.isEmpty(adminartifactsharingsettings) ? adminartifactsharingsettings : [];

      const artifactDocList = resultFrom ? sortedRoleState : sectionSortedRoleState;


      return updateObject(state, {
        docLoading: false,
        documentDataList: { ...state.documentDataList, ...artifactDocList },
        loadingArtifact: [...newList1],
        sectionLoading: false,
        sharingDetails: [state.sharingDetails, ...adminSharing],
        latestDocumentDetails: documentDetails,
      });

    case "RESET_DOCUMENT_DATA_LIST":
      let currentPayload = action.payload;
      let doucmentList = state.documentDataList;
      let ModifiedPayload;

      if (!doucmentList[currentPayload.origiartifactid]) {
        ModifiedPayload = { ...doucmentList, ...currentPayload }
      } else {
        doucmentList[currentPayload.origiartifactid].unshift(currentPayload);
        ModifiedPayload = { ...doucmentList, ...currentPayload  }; //Due to this else part, added currentpayload array value with documentlist. Since doucmentList refer to first file bulk upload
      }
      return updateObject(state, {
        documentDataList: ModifiedPayload,
      });

    case actionTypes.SCANNING_PROCESS_STATUS:
      return updateObject(state, {});

    case `${actionTypes.SCANNING_PROCESS_STATUS}_SUCCESS`:
      let Payload = action.payload;
      let fullList = state.documentDataList;

      if (fullList[Payload?.docObject?.origiartifactid]) {
        const selectedList = fullList[
          Payload?.docObject?.origiartifactid
        ].findIndex((item) => item.documentid === Payload.id);
        Payload.status = "Unpublished";
        const mergeValue = {
          ...fullList[Payload?.docObject?.origiartifactid][selectedList],
          ...Payload,
        };
        fullList[Payload?.docObject?.origiartifactid][selectedList] =
          mergeValue;
      }

      let inProgressObject = fullList[
        Payload?.docObject?.origiartifactid
      ].filter((i) => !i.docid);
      let ProgressObject = fullList[Payload?.docObject?.origiartifactid].filter(
        (i) => i.docid
      );
      if (inProgressObject?.length > 0) {
        ProgressObject.unshift(...inProgressObject);
      }

      fullList[Payload?.docObject?.origiartifactid] = ProgressObject;

      return updateObject(state, {
        documentDataList: fullList,
      });

    case "CANCEL_UPLOAD_DATA":
      let cancelPayload = action.payload;
      let dataList = state.documentDataList;
      const convertParse = JSON.parse(cancelPayload.documentcontent);
      if (dataList[convertParse?.documentDetails?.origiartifactid]) {
        const selectedList = dataList[
          convertParse?.documentDetails?.origiartifactid
        ].filter(
          (item) => item.documentid !== convertParse.documentDetails.documentid
        );
        dataList[convertParse?.documentDetails?.origiartifactid] = selectedList;
      }
      return updateObject(state, {
        documentDataList: dataList,
      });

    case "CANCLE_LOCAL_DOCUMENT":
      let localCancel = action.payload;
      let newData = state.documentDataList;
      let updateData = newData[localCancel.origiartifactid].filter(
        (i) => i.documentid !== localCancel.documentid
      );
      newData[localCancel.origiartifactid] = updateData;
      return updateObject(state, {
        documentDataList: newData,
      });

    case actionTypes.FILE_UPLOAD_SUCCESS:
      return updateObject(state, {
        fileDetails: action.payload,
        // uploadProgress: { ...action.payload } 
      });

    case actionTypes.FILE_UPLOAD_FAILED:
      return updateObject(state, {
        fileDetails: {},
        failedFileDetails: action.payload,
      });

    case actionTypes.FILE_UPLOAD_PROGRESS:
      if (state.documentDataList[action.payload.artifactId]) {
        const findIndexState = state.documentDataList[
          action.payload.artifactId
        ].findIndex((item) => item.documentid === action.payload.id);

        if (findIndexState >= 0) {
          state.documentDataList[action.payload.artifactId][
            findIndexState
          ].uploadProgress = action.payload.docObject.uploadingProgress;
        }
      }
      return updateObject(state, {
        documentDataList: state.documentDataList,
        uploadProgress: { ...action.payload },
      });

    case actionTypes.FETCH_METRICS_DATA:
      return updateObject(state, { isOverViewLoading: true });
    case `${actionTypes.FETCH_METRICS_DATA}_SUCCESS`:
      let initialLoad = state.initialOverviewPageLoad;
      if (!_.isEmpty(action.payload)) {
        initialLoad = false
      }
      return updateObject(state, {
        metricsData: action.payload,
        isOverViewLoading: false,
        initialOverviewPageLoad: initialLoad
      });
    case `${actionTypes.FETCH_METRICS_DATA}_FAILED`:
      return updateObject(state, { metricsData: {}, isOverViewLoading: false, initialOverviewPageLoad: false });
    case `${actionTypes.SHOW_ZONE_LOADER}`:
      return updateObject(state, { isZoneLoading: true });
    case `${actionTypes.HIDE_ZONE_LOADER}`:
      return updateObject(state, { isZoneLoading: false });

    case `${actionTypes.GET_ROLE_LIST}_SUCCESS`:
      let updateRoleList = action.payload;
      updateRoleList = updateRoleList.map((obj) => ({
        id: obj.roleId,
        text: obj.roleName,
      }));
      let tmfList = [];
      let auditList = [];
      let listAudit = [];
      updateRoleList.forEach(function (role) {
        if (role.text === "Archive sponsor TMF") {
          tmfList.push({ id: "Sponsor", text: "Sponsor" });
        } else if (role.text === "Archive investigator TMF") {
          tmfList.push({ id: "Investigator", text: "Investigator" });
        } else if (role.text === "Download audit trail") {
          auditList.push({ id: "Audit", text: "Audit" });
        }
      });
      if (!_.isEmpty(auditList)) {
        listAudit.push({
          name: "auditTrailReport",
          label: "Audit trail report",
          key: "audit",
        });
      }
      if (!_.isEmpty(tmfList)) {
        listAudit.push({
          name: "emsRepository",
          label: "eTMF - EMS repository",
          key: "archive",
        });
      }
      const readOnlyAdminList = state.apiInitConfigObj["readonlyadmin"];
      const readOnlyUserList = state.apiInitConfigObj["readonlyuser"];
      const readOnlyAdmin = _.findIndex(updateRoleList, {
        id: !_.isEmpty(readOnlyAdminList) ? readOnlyAdminList[0] : "",
      });
      const checkIsReadOnlyUser = () => {
        const readOnlyUser = _.findIndex(updateRoleList, {
          id: !_.isEmpty(readOnlyUserList) ? readOnlyUserList[0] : "",
        });
        const etmfManager = _.findIndex(updateRoleList, { id: "ETMFMANAGER" });

        let returnValue = false;
        if (readOnlyUser !== -1) {
          returnValue =
            updateRoleList.length === 1 ||
            (updateRoleList.length === 2 &&
              (etmfManager !== -1 || readOnlyAdmin !== -1)) ||
            (updateRoleList.length === 3 &&
              etmfManager !== -1 &&
              readOnlyAdmin !== -1);
        }
        return returnValue;
      };
      const checkIsReadOnlySharingPanel = () => {
        const readOnlyUser = _.findIndex(updateRoleList, {
          id: !_.isEmpty(readOnlyUserList) ? readOnlyUserList[0] : "",
        });
        return readOnlyUser !== -1 ? true : false;
      }
      let isViedocUser = updateRoleList.length !== 0 && !_.isEmpty(updateRoleList.filter((role) => role.id === "MANAGE_DOCSHARE_VIEDOCUSERS")) ? true : false;
      let isViedocMeUser = updateRoleList.length !== 0 && !_.isEmpty(updateRoleList.filter((role) => role.id === "MANAGE_DOCSHARE_VIEDOCMEUSERS")) ? true : false;
      let isManageDropZoneAvailable = updateRoleList.length !== 0 && !_.isEmpty(updateRoleList.filter((role) => role.id === "MANAGE_DROPZONE")) ? true : false;
      return updateObject(state, {
        tmfList: tmfList,
        auditList: auditList,
        listAudit: listAudit,
        roleList: updateRoleList,
        isReadOnlyAdmin: readOnlyAdmin !== -1,
        isReadOnlyUser: checkIsReadOnlyUser(),
        isDocShareViedocUser: isViedocUser,
        isDocShareViedocMeUser: isViedocMeUser,
        isReadOnlySharingPanel: checkIsReadOnlySharingPanel(),
        isManageDropZoneAvailable: isManageDropZoneAvailable,
        isRoleListLoaded: true,
      });

    case `${actionTypes.GET_ROLE_LIST}_FAILED`:
      return updateObject(state, {
        tmfList: [],
        auditList: [],
        listAudit: [],
        roleList: [],
        isReadOnlyAdmin: "",
        isReadOnlyUser: "",
        isRoleListLoaded: false,
      });

    case `${actionTypes.GET_STUDY_INFO}_SUCCESS`:
      const studyInfo = {
        ...state.studyUserInfo,
        ...action.payload,
      };
      return updateObject(state, { studyUserInfo: studyInfo });
    case `${actionTypes.GET_USER_INFO}_SUCCESS`:
      const userInfo = {
        ...state.studyUserInfo,
        ...action.payload,
      };
      return updateObject(state, { studyUserInfo: userInfo });
    case `${actionTypes.GET_USER_LIST}_SUCCESS`:
      let updateUserList = action.payload;
      const systemAsUser = {
        displayName: "System(0)",
        guid: "00000000-0000-0000-0000-000000000001",
      };
      updateUserList.push(systemAsUser);
      return updateObject(state, {
        userList: updateUserList,
        isEditLoading: false,
      });
    case `${actionTypes.GET_ORG_ID}_SUCCESS`:
      return updateObject(state, { orgGuid: action.payload });

    case actionTypes.GO_TO_BROWSER_VIEW:
      return updateObject(state, { searchView: false, searchResult: [] });

    case `${actionTypes.GET_APP_INIT_CONFIG}_SUCCESS`:
      return updateObject(state, { apiInitConfigObj: action.payload });

    case `${actionTypes.GET_COUNTRY_SITE_LIST}_SUCCESS`:
      const { dropDownName, result } = action.payload;
      const updateCountryList = { ...state.countrySiteList };
      let updateResult = [];
      if (dropDownName === "site")
        updateResult = result.map((obj) => ({
          id: obj.guid,
          text: obj.siteName,
          description: obj.siteName,
          countryCode: obj.countryCode,
          siteCode: obj.siteCode,
        }));
      else
        updateResult = result.map((obj) => ({
          id: obj.countryCode,
          text: obj.country,
          description: obj.country,
          countrycode: obj.countryCode,
        }));
      updateCountryList[`${dropDownName}`] = updateResult;
      return updateObject(state, {
        countrySiteList: updateCountryList,
        archiveSiteLoad: false,
      });

    case `${actionTypes.GET_DOCUMENT_BY_ARTIFACT}`:
      let newList = [...state.loadingArtifact, action.payload];
      return updateObject(state, {
        loadingArtifact: [...newList],
        artifactLoading: true,
      });

    case `${actionTypes.GET_DOCUMENT_BY_ARTIFACT}_SUCCESS`:
      let newDocDetails;
      if (action.fileguid) {
        newDocDetails = action.payload.documentDetails.find(
          (movedDoc) => movedDoc.documentid === action.fileguid
        );
      }
      return updateObject(state, {
        artifactLoading: false,
        relocatedDoc: newDocDetails,
      });

    case `${actionTypes.GET_DOCUMENT_BY_ARTIFACT}_FAILED`:
      return updateObject(state, {
        artifactLoading: false,
        relocatedDoc: {},
      });

    case `${actionTypes.FETCH_ZONE_DATA}_SUCCESS`:
      let updatedZoneList = action.payload || [];
      return updateObject(state, { zoneItems: updatedZoneList });

    case actionTypes.TO_PASS_MODIFIED_FILE_DATA:
      return updateObject(state, { newlyModifiedDocumentData: action.payload, ismodifiedDocument: action.ismodifiedDocument });

    case actionTypes.CANCEL_DOC_ID:
      return updateObject(state, { cancelDocId: [...state.cancelDocId, action.payload] });

    case actionTypes.RECORD_STATE:
      return updateObject(state, { recordState: action.payload });
    case actionTypes.DOC_NEW_VERSION_XFDF_STRING:
      return updateObject(state, { docNewVersionXFDFString: action.payload });  
    case actionTypes.UPLOADED_NEW_VERSION_FILE:
      return updateObject(state, { isUploadedNewVersionFile: action.payload });   
    case actionTypes.CLEAR_DOCUMENT_DATA_LIST:
      return updateObject(state, { documentDataList: []})
    default:
      return state;
  }
};
